import { otpHost } from 'config/env.conf';
import InnerFrame from 'components/inner-frame/inner-frame';
const baseUrl = `${otpHost}/#/account/`;

export default [{
    name: 'adminAccount',
    path: 'admin',
    component: InnerFrame,
    meta: {
        title: "账号管理",
        notMenu: true,
        src: baseUrl + 'admin',
        noAuth: true,
        icon: 'person'
    }
},
{
    name: 'subAccount',
    path: 'sub',
    component: InnerFrame,
    meta: {
        title: "账号管理",
        notMenu: true,
        src: baseUrl + 'sub',
        noAuth: true,
        icon: 'person'
    },
}
];


// WEBPACK FOOTER //
// ./src/router/router.account.js